import { render, staticRenderFns } from "./SalaryBoard.vue?vue&type=template&id=029138d8&scoped=true"
import script from "./SalaryBoard.vue?vue&type=script&lang=js"
export * from "./SalaryBoard.vue?vue&type=script&lang=js"
import style0 from "./SalaryBoard.vue?vue&type=style&index=0&id=029138d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029138d8",
  null
  
)

export default component.exports